import { FC } from 'react';
import { get, isNil } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import Document from 'components/Document';
import { BlobProvider } from '@react-pdf/renderer';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SecondExaminationLetter from 'components/SecondExaminationLetter';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import { InputWithoutPaddingWrapper } from 'containers/CourtManagerAssignedExpertise/style';
import { getCity } from 'containers/RecapManagerPage/utils';

interface TextElementProps {
  intl: IntlShape;
  listings: any;
  mission: any;
}

const LetterSecondExamination: FC<TextElementProps> = props => {
  const getExpertInfo = (expertCode: any) => {
    const expertInfo = get(props.listings, 'intervenants')?.find(
      (item: any) => Number(item.ItemKey) === Number(expertCode),
    );
    const expertTown =
      expertInfo?.townCode &&
      getCity(get(props.listings, 'villes', []), expertInfo?.townCode as any);
    return {
      ...expertInfo,
      cellPhone: '*****',
      address: expertTown?.address,
      expertTown: expertTown?.ItemDescription,
    };
  };
  return (
    <>
      <h3 style={{ padding: 'unset' }}>
        {translate(messages.secondExaminationLetter, props)}
      </h3>
      {props.mission.assignedExpert.map((item: any) => (
        <InputWithoutPaddingWrapper>
          <Document
            name={translate(messages.secondExaminationLetter, props)}
            type={translate(messages.secondExaminationLetter, props)}
            icon={
              <BlobProvider
                document={
                  (
                    <SecondExaminationLetter
                      data={{
                        ...props.mission,
                        expertInfo: getExpertInfo(item.expertCode),
                        clientIntro: !isNil(
                          get(
                            props.mission,
                            'secondExamination.opposingLawyerId',
                            null,
                          ),
                        )
                          ? 'Maître'
                          : 'Mr/Mme',
                        adressText: !isNil(
                          get(
                            props.mission,
                            'secondExamination.victimId',
                            null,
                          ),
                        )
                          ? ' de vous adresser'
                          : ' d’adresser votre client',
                        clientInfo: !isNil(
                          get(
                            props.mission,
                            'secondExamination.victimId',
                            null,
                          ),
                        )
                          ? {
                              fullName:
                                get(props.mission, 'victims[0].firstName') +
                                ' ' +
                                get(props.mission, 'victims[0].lastName'),
                              adress: get(props.mission, 'victims[0].address'),
                              town: getCity(
                                get(props.listings, 'villes', []),
                                String(
                                  get(props.mission, 'victims[0].city'),
                                ) as any,
                              )?.ItemDescription,
                            }
                          : {
                              fullName: get(
                                props.mission,
                                'secondExamination.opposingLawyer.name',
                              ),
                              adress: get(
                                props.mission,
                                'secondExamination.opposingLawyer.address',
                              ),
                              town: getCity(
                                get(props.listings, 'villes', []),
                                String(
                                  get(
                                    props.mission,
                                    'secondExamination.opposingLawyer.city',
                                  ),
                                ) as any,
                              )?.ItemDescription,
                            },
                        reference: props.mission?.missionNumber,
                        victimName:
                          get(props.mission, 'victims[0].firstName') +
                          ' ' +
                          get(props.mission, 'victims[0].lastName'),
                      }}
                    />
                  ) as any
                }
              >
                {params => {
                  return (
                    <a
                      href={params.url ? params.url : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <VisibilityIcon
                        style={{ color: 'black' }}
                        className="consult"
                      />
                    </a>
                  );
                }}
              </BlobProvider>
            }
          />
        </InputWithoutPaddingWrapper>
      ))}
    </>
  );
};

export default injectIntl(LetterSecondExamination);
